var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBottomMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.47711 15.0007C4.85782 15.0007 5.97711 13.8814 5.97711 12.5007C5.97711 11.12 4.85782 10.0007 3.47711 10.0007C2.0964 10.0007 0.977112 11.12 0.977112 12.5007C0.977112 13.8814 2.0964 15.0007 3.47711 15.0007Z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5227 15.0007C14.9034 15.0007 16.0227 13.8814 16.0227 12.5007C16.0227 11.12 14.9034 10.0007 13.5227 10.0007C12.142 10.0007 11.0227 11.12 11.0227 12.5007C11.0227 13.8814 12.142 15.0007 13.5227 15.0007Z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47711 5.00043C4.85782 5.00043 5.97711 3.88114 5.97711 2.50043C5.97711 1.11972 4.85782 0.000427246 3.47711 0.000427246C2.0964 0.000427246 0.977112 1.11972 0.977112 2.50043C0.977112 3.88114 2.0964 5.00043 3.47711 5.00043Z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5227 5.00043C14.9034 5.00043 16.0227 3.88114 16.0227 2.50043C16.0227 1.11972 14.9034 0.000427246 13.5227 0.000427246C12.142 0.000427246 11.0227 1.11972 11.0227 2.50043C11.0227 3.88114 12.142 5.00043 13.5227 5.00043Z",
    fill: props.fill
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBottomMenu);
export default __webpack_public_path__ + "static/media/icon_bottomMenu.b66ee1ba57d3db9faa5a9b16887ab6b2.svg";
export { ForwardRef as ReactComponent };